export var PaymentTypesIdEnum;
(function (PaymentTypesIdEnum) {
    PaymentTypesIdEnum[PaymentTypesIdEnum["Unsupported"] = 0] = "Unsupported";
    PaymentTypesIdEnum[PaymentTypesIdEnum["CreditCard"] = 1] = "CreditCard";
    PaymentTypesIdEnum[PaymentTypesIdEnum["DebitCard"] = 2] = "DebitCard";
    PaymentTypesIdEnum[PaymentTypesIdEnum["PayPal"] = 14] = "PayPal";
    PaymentTypesIdEnum[PaymentTypesIdEnum["ApplePay"] = 31] = "ApplePay";
    PaymentTypesIdEnum[PaymentTypesIdEnum["GooglePay"] = 32] = "GooglePay";
})(PaymentTypesIdEnum || (PaymentTypesIdEnum = {}));
export var PaymentCardTypeIdEnum;
(function (PaymentCardTypeIdEnum) {
    PaymentCardTypeIdEnum[PaymentCardTypeIdEnum["PayPalV2"] = 365] = "PayPalV2";
    PaymentCardTypeIdEnum[PaymentCardTypeIdEnum["PayPalPayLater"] = 366] = "PayPalPayLater";
})(PaymentCardTypeIdEnum || (PaymentCardTypeIdEnum = {}));
export var PaymentMethodsEnum;
(function (PaymentMethodsEnum) {
    PaymentMethodsEnum["CARD"] = "card";
    PaymentMethodsEnum["PAYPAL"] = "paypal";
    PaymentMethodsEnum["PAYPAL_V2"] = "paypalv2";
    PaymentMethodsEnum["PAYPAL_PAY_LATER"] = "paylater";
    PaymentMethodsEnum["APPLE_PAY"] = "apple";
    PaymentMethodsEnum["G_PAY"] = "gpay";
})(PaymentMethodsEnum || (PaymentMethodsEnum = {}));
